import { Component } from "react";
import { Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import i18n from "../i18n";
import styles from "./RateAppDialog.module.scss";
import RateAppService from "../common/RateAppService";
import type { ModalChildProps } from './ModalComponent';

/**
 * Dialog component that asks the user to rate the app.
 * Shows two options: "Valorar" and "No, gracias".
 */
export default class RateAppDialog extends Component<ModalChildProps> {
    constructor(props: ModalChildProps) {
        super(props);
        this.handleRate = this.handleRate.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    // Needed to avoid aria-hidden warning when opening the modal from Drawer items.
    componentDidMount(): void {
        const active = document.activeElement as HTMLElement | null;
        if (active && active.blur) {
            active.blur();
        }
    }

    // Triggers the native review prompt and closes the dialog.
    handleRate(): void {
        RateAppService.rateApp();
    }

    // Dismisses the dialog without rating.
    handleDismiss(): void {
        RateAppService.dismiss();
    }

    render() {
        return (
            <div className={styles.rateAppDialog}>
                <Typography variant="h6" className={styles.message}>
                    {i18n.t("rateApp.message1")}
                    <br/>
                    {i18n.t("rateApp.message2")}
                </Typography>
                <div className={styles.buttonsContainer}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleRate}
                    >
                        {i18n.t("rateApp.accept")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={this.handleDismiss}
                    >
                        {i18n.t("rateApp.dismiss")}
                    </Button>
                </div>
            </div>
        );
    }
}
